import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const OutlinedCalendarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.375 6.875H5.625V8.125H4.375V6.875ZM4.375 9.375H5.625V10.625H4.375V9.375ZM6.875 6.875H8.125V8.125H6.875V6.875ZM6.875 9.375H8.125V10.625H6.875V9.375ZM9.375 6.875H10.625V8.125H9.375V6.875ZM9.375 9.375H10.625V10.625H9.375V9.375Z"
          fill="var(--mui-palette-text-secondary)"
        />
        <path
          d="M3.125 13.75H11.875C12.5644 13.75 13.125 13.1894 13.125 12.5V3.75C13.125 3.06062 12.5644 2.5 11.875 2.5H10.625V1.25H9.375V2.5H5.625V1.25H4.375V2.5H3.125C2.43562 2.5 1.875 3.06062 1.875 3.75V12.5C1.875 13.1894 2.43562 13.75 3.125 13.75ZM11.875 5L11.8756 12.5H3.125V5H11.875Z"
          fill="var(--mui-palette-text-secondary)"
        />
      </svg>
    </SvgIcon>
  );
};

export default OutlinedCalendarIcon;
